<template>
  <Modal ref="modalRef" info>
    <template #title>Upload options</template>

    <p class="help-text">Choose what to include when your tree is uploaded.</p>
    <div class="options" v-if="currentRef">
      <div class="option">
        <label>
          <input type="checkbox" class="form-check-input" v-model="currentRef.syncOptions.includeLivingPersons" :disabled="!livingWindowCountRef"/>
          Include living people
        </label>
        <button type="button" class="btn btn-inline btn-link" :disabled="!livingWindowCountRef" @click="onEditLiving">
          {{ livingPeopleLinkTextRef }}
        </button>
      </div>
      <!-- <div class="option disabled">
        <label>
          <input type="checkbox" class="form-check-input" v-model="syncOptions.includeContent" disabled/>
          Photos &amp; documents
        </label>
      </div> -->
      <label class="form-label soon">
        Coming soon
      </label>
      <div class="option disabled">
        <label>
          <input type="checkbox" class="form-check-input" disabled/>
          Sources &amp; notes
        </label>
      </div>
      <div class="option disabled">
        <label>
          <input type="checkbox" class="form-check-input" disabled/>
          LDS details
        </label>
      </div>
    </div>
    <template #okText>Done</template>
  </Modal>
</template>

<style lang="scss" scoped>
.options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .option {
    margin-left: 1rem;
  }

  .option.disabled {
    label {
      color: #aaa;
    }
  }

  label {
    display: block;

    & + * {
      margin-left: 1.5rem;
    }
  }

  .btn-link {
    font-size: 0.875rem;
  }

  .soon {
    margin-top: 1rem;
  }
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import Modal from '@webapp/util/Modal.vue'
import { useSyncSessionStore } from './SyncSessionStore'

const props = defineProps<{
  sessionId: string
}>()

const emit = defineEmits(['editLiving'])

defineExpose({
  open,
})

const syncSessionStore = useSyncSessionStore()
const currentRef = computed(() => syncSessionStore.getState(props.sessionId))

const livingWindowCountRef = computed(() => currentRef.value?.sourceGraph?.livingWindowPersonIds.size ?? 0)
const livingPeopleLinkTextRef = computed(() => {
  if (livingWindowCountRef.value === 0) {
    return 'No living people found'
  }
  return `${currentRef.value?.livingWindowPersonIds.length ?? 0} of ${livingWindowCountRef.value} living people selected`
})

const modalRef = ref<InstanceType<typeof Modal>>()

function open() {
  modalRef.value?.open()
}

async function onEditLiving() {
  // Fully hide the modal (and its backdrop) before the parent opens the living-people modal.
  await modalRef.value?.close()
  emit('editLiving')
}
</script>
